/**
 * Global corner radii - used while iterating on the new design.
 *
 * Each selected value is published as a CSS variable on the document root;
 * the rules consuming them live in `src/styles/settings.scss`.
 */
import { ref, watch, type Ref } from "vue";

export interface RadiusOption {
  // key of the translation with the human readable name
  key: string;
  value: string;
}

export const RADIUS_OPTIONS: RadiusOption[] = [
  { key: "x_small", value: "4px" },
  { key: "small", value: "8px" },
  { key: "medium", value: "12px" },
  { key: "large", value: "16px" },
  { key: "x_large", value: "26px" },
  { key: "full", value: "999px" },
];

function createRadius(
  storageKey: string,
  cssVariable: string,
  defaultValue: string,
): Ref<string> {
  const stored = window.localStorage.getItem(storageKey);
  const radius = ref(
    RADIUS_OPTIONS.some((option) => option.value === stored)
      ? (stored as string)
      : defaultValue,
  );
  watch(
    radius,
    (value) => {
      document.documentElement.style.setProperty(cssVariable, value);
      window.localStorage.setItem(storageKey, value);
    },
    { immediate: true },
  );
  return radius;
}

// large
export const buttonRadius = createRadius(
  "celus.buttonRadius",
  "--celus-button-radius",
  "16px",
);

// extra large - cards used to be `rounded="xl"` (24px), 26px is the closest option
export const cardRadius = createRadius(
  "celus.cardRadius",
  "--celus-card-radius",
  "26px",
);

export const RADII: Record<string, Ref<string>> = {
  button: buttonRadius,
  card: cardRadius,
};
